module.exports = __webpack_public_path__ + "assets/img/browser-icon.668700f0.png";